module.exports = __webpack_public_path__ + "img/jordan-1.9c1af769.png";